module.exports = __webpack_public_path__ + "static/media/search-mobile.46f513da.jpg";